<template>
  <div class="system-container">
    <BContainer fluid class="p-0">
      <BRow class="g-0">
        <BCol>
          <BCard no-body class="modern-card">
            <div class="tab-content-wrapper p-4">
              <BRow>
                <BCol class="d-flex justify-content-end mb-3">
                <BButton
                  @click="() => $refs.NewWinterSettingModal.show()"
                  variant="primary"
                  size="md"
                  class="px-4 py-2 add-setting-btn"
                >
                  <i class="bi bi-plus-circle me-2"></i>新しい設定を追加
                </BButton>
              </BCol>
            </BRow>

                <BRow class="mt-2">
                  <BCol>
                    <BTable
                      class="text-center"
                      striped
                      hover
                      :items="l_winterStationSettingTableData"
                      :fields="l_winterStationSettingTableFields"
                      :per-page="l_winterStationSettingTableViewPerPage"
                      :current-page="l_winterStationSettingTableCurrentPage"
                    >
                      <template #cell(設定変更)="row">
                        <BButton
                          size="sm"
                          class="mr-2"
                          @click="() => {
                            setEditingData(row.item);
                            $refs.EditWinterSettingModal.show();
                          }"
                        >
                          <i class="bi bi-pencil-square mr-1"></i>編集
                        </BButton>
                      </template>
                    </BTable>
                    <BPagination
                      v-model="l_winterStationSettingTableCurrentPage"
                      :total-rows="getWinterStationSettingTableRows"
                      :per-page="l_winterStationSettingTableViewPerPage"
                      aria-controls="my-table"
                    </BPagination>
                  </BCol>
                </BRow>
            </div>
          </BCard>
        </BCol>
      </BRow>
    </BContainer>

    <!-- 編集モーダル -->
    <BModal
      ref="EditWinterSettingModal"
      modal-class="newmodal"
      no-close-on-esc
      no-close-on-backdrop
      @hide="initSelection"
    >
      <template #header>
        <h5 class="newmodal">冬期非表示設定を編集する</h5>
      </template>

      <div class="newmodal">
        <BRow>
          <BCol>
            <label for="editsetting-name">設定名</label>
            <BFormInput
              id="editsetting-name"
              v-model="l_editWinterStationSettingValue.name"
              maxlength="20"
              :disabled="l_editSettingProcessing || l_editSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="editsetting-keyword">キーワード</label>
            <BFormInput
              id="editsetting-keyword"
              v-model="l_editWinterStationSettingValue.keyword"
              maxlength="20"
              :disabled="l_editSettingProcessing || l_editSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="editsetting-startdate">開始日</label>
            <BFormInput
              id="editsetting-startdate"
              type="date"
              v-model="l_editWinterStationSettingValue.startdate"
              @input="initEditStartDate"
              :disabled="l_editSettingProcessing || l_editSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="editsetting-enddate">終了日</label>
            <BFormInput
              id="editsetting-enddate"
              type="date"
              :disabled="l_editSettingProcessing || l_editSettingCompleted || l_editWinterStationSettingValue.startdate==''"
              v-model="l_editWinterStationSettingValue.enddate"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <BFormGroup label="有効/無効" v-slot="{ ariaDescribedby }">
              <BFormRadioGroup
                id="editsetting-valid"
                v-model="l_editWinterStationSettingValue.valid"
                :options="l_winterStationSettingValidOptions"
                :aria-describedby="ariaDescribedby"
                name="editsetting-valid"
                :disabled="l_editSettingProcessing || l_editSettingCompleted"
              />
            </BFormGroup>
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="editsetting-description">説明</label>
            <BFormInput
              id="editsetting-description"
              v-model="l_editWinterStationSettingValue.description"
              maxlength="20"
              :disabled="l_editSettingProcessing || l_editSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="editsetting-createdate">作成日</label>
            <BFormInput
              id="editsetting-createdate"
              type="date"
              disabled
              v-model="l_editWinterStationSettingValue.createdate"
            />
          </BCol>
        </BRow>
      </div>

      <BButton
        :disabled="l_editSettingProcessing || l_editSettingCompleted || getEditButtonAvailability()"
        class="w-100 mt-2 newmodal"
        variant="info"
        @click="requestWinterStationHideEditRequestWrapper(l_editWinterStationSettingValue)"
      >
        <div v-if="!l_editSettingCompleted">
          更新する
          <BSpinner v-if="l_editSettingProcessing" label="Spinning" small class="ml-2" />
        </div>
        <div v-else>完了しました</div>
      </BButton>

      <template #footer>
        <BButton
          v-if="!l_editSettingCompleted"
          :disabled="l_editSettingProcessing"
          class="newmodal"
          variant="secondary"
          @click="$refs.EditWinterSettingModal.hide()"
        >
          いいえ(中止します)
        </BButton>
        <BButton
          v-else
          :disabled="l_editSettingProcessing"
          class="newmodal"
          variant="secondary"
          @click="$refs.EditWinterSettingModal.hide()"
        >
          閉じる
        </BButton>
      </template>
    </BModal>

    <!-- 新規追加モーダル -->
    <BModal
      ref="NewWinterSettingModal"
      modal-class="newmodal"
      no-close-on-esc
      no-close-on-backdrop
      @hide="initSelection"
    >
      <template #header>
        <h5 class="newmodal">冬期非表示設定を追加する</h5>
      </template>

      <div class="newmodal">
        <BRow>
          <BCol>
            <label for="newsetting-name">設定名</label>
            <BFormInput
              id="newsetting-name"
              v-model="l_newWinterStationSettingValue.name"
              maxlength="20"
              :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="newsetting-keyword">キーワード</label>
            <BFormInput
              id="newsetting-keyword"
              v-model="l_newWinterStationSettingValue.keyword"
              maxlength="20"
              :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="newsetting-startdate">開始日</label>
            <BFormInput
              id="newsetting-startdate"
              type="date"
              v-model="l_newWinterStationSettingValue.startdate"
              @input="initNewStartDate"
              :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="newsetting-enddate">終了日</label>
            <BFormInput
              id="newsetting-enddate"
              type="date"
              :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted || l_newWinterStationSettingValue.startdate==''"
              v-model="l_newWinterStationSettingValue.enddate"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <BFormGroup label="有効/無効" v-slot="{ ariaDescribedby }">
              <BFormRadioGroup
                id="newsetting-valid"
                v-model="l_newWinterStationSettingValue.valid"
                :options="l_winterStationSettingValidOptions"
                :aria-describedby="ariaDescribedby"
                name="newsetting-valid"
                :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted"
              />
            </BFormGroup>
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="newsetting-description">説明</label>
            <BFormInput
              id="newsetting-description"
              v-model="l_newWinterStationSettingValue.description"
              maxlength="20"
              :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted"
            />
          </BCol>
        </BRow>
        <BRow class="mt-2">
          <BCol>
            <label for="newsetting-createdate">作成日</label>
            <BFormInput
              id="newsetting-createdate"
              type="date"
              disabled
              v-model="l_newWinterStationSettingValue.createdate"
            />
          </BCol>
        </BRow>
      </div>

      <BButton
        :disabled="l_addnewSettingProcessing || l_addnewSettingCompleted || getAddNewButtonAvailability()"
        class="w-100 mt-2 newmodal"
        variant="info"
        @click="requestWinterStationAddRequestWrapper(l_newWinterStationSettingValue)"
      >
        <div v-if="!l_addnewSettingCompleted">
          追加する
          <BSpinner v-if="l_addnewSettingProcessing" label="Spinning" small class="ml-2" />
        </div>
        <div v-else>完了しました</div>
      </BButton>

      <template #footer>
        <BButton
          v-if="!l_addnewSettingCompleted"
          :disabled="l_addnewSettingProcessing"
          class="newmodal"
          variant="secondary"
          @click="$refs.NewWinterSettingModal.hide()"
        >
          いいえ(中止します)
        </BButton>
        <BButton
          v-else
          :disabled="l_addnewSettingProcessing"
          class="newmodal"
          variant="secondary"
          @click="$refs.NewWinterSettingModal.hide()"
        >
          閉じる
        </BButton>
      </template>
    </BModal>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment"
export default {
  data() {
    return {
      l_winterStationSettingTableViewPerPage: 10,
      l_winterStationSettingTableCurrentPage: 1,
      l_winterStationSettingTableData : [],
      l_winterStationSettingTableFields : ['設定名', 'キーワード', '開始日', '終了日', '有効/無効', '説明', '作成日', '設定変更'],
      l_winterStationSettingValidOptions : [
        {value:true, text:"有効"},
        {value:false, text:"無効"}
      ],
      l_newWinterStationSettingValue : {
        name : "",
        keyword : "",
        startdate : "",
        enddate : "",
        valid : false,
        description : "",
        createdate : moment().format('YYYY-MM-DD')
      },
      l_editWinterStationSettingValue : {
        name : "",
        keyword : "",
        startdate : "",
        enddate : "",
        valid : false,
        description : "",
        createdate : ""
      },

      l_editSettingProcessing:false,
      l_editSettingCompleted:false,
      l_addnewSettingProcessing:false,
      l_addnewSettingCompleted:false
    }
  },
  // Initialized Event & Lifecycle
  beforeCreate() {
  },
  // Initialized Injection & Reactivity
  created() {
  },
  // Processed the following
  beforeMount() {
    // 1.Has "el" option?
    //   Yes  -> No action
    //   No   -> vm.&mount(el) is called.
    // 2.Has "template" option?
    //   Yes  -> Compile template into render function.
    //   No   -> Compile el's outerHTML as template
  },
  // Created vm.$el and replaced "el" with it.
  mounted() {
    this.getWinterStationHideRequestWrapper();
  },
  // Data changed in mounted state.
  beforeUpdate() {
  },
  // Virtual DOM re-rendered and patched in mounted state.
  updated() {
  },
  // vm.$destroy() is called.
  beforeUnmount() {
  },
  // Teardown completed watchers, child components and event listeners
  unmounted() {
  },
  computed: {
    getWinterStationSettingTableRows() {
      return this.l_winterStationSettingTableData.length
    },
  },
  watch: {
  },
  methods:{
    initSelection(){
      this.l_newWinterStationSettingValue = {
        name : "",
        keyword : "",
        startdate : "",
        enddate : "",
        valid : false,
        description : "",
        createdate : moment().format('YYYY-MM-DD')
      }
      this.l_editWinterStationSettingValue = {
        name : "",
        keyword : "",
        startdate : "",
        enddate : "",
        valid : false,
        description : "",
        createdate : ""
      },

      this.l_editSettingProcessing = false
      this.l_editSettingCompleted = false
      this.l_addnewSettingProcessing = false
      this.l_addnewSettingCompleted = false
    },
    initNewStartDate(){
      this.l_newWinterStationSettingValue.enddate = ""
    },
    initEditStartDate(){
      this.l_editWinterStationSettingValue.enddate = ""
    },
    setEditingData(event){
      var edit_name = event['設定名']
      var edit_id = event['設定ID']
      var edit_keyword = event['キーワード']
      var edit_startdate = event['開始日'].replaceAll("/","-")
      var edit_enddate = event['終了日'].replaceAll("/","-")
      var edit_valid = (event['有効/無効'] == "有効" ? true : false)
      var edit_description = event['説明']
      var edit_createdate = event['作成日'].replaceAll("/","-")

      this.l_editWinterStationSettingValue = {
        name : edit_name,
        settingId : edit_id,
        keyword : edit_keyword,
        startdate : edit_startdate,
        enddate : edit_enddate,
        valid : edit_valid,
        description : edit_description,
        createdate : edit_createdate
      }
    },
    dateDisabledNew(ymd, date){
        // Disable weekends (Sunday = `0`, Saturday = `6`) and
        // disable days that fall on the 13th of the month
        // const weekday = date.getDay()
        // const day = date.getDate()
        // Return `true` if the date should be disabled
        return date < new Date(this.l_newWinterStationSettingValue.startdate)
    },
    dateDisabledEdit(ymd, date){
        // Disable weekends (Sunday = `0`, Saturday = `6`) and
        // disable days that fall on the 13th of the month
        // const weekday = date.getDay()
        // const day = date.getDate()
        // Return `true` if the date should be disabled
        return date < new Date(this.l_editWinterStationSettingValue.startdate)
    },
    getAddNewButtonAvailability(){
      var ret = true
      if(this.l_newWinterStationSettingValue.name == '' ||
        this.l_newWinterStationSettingValue.keyword == '' ||
        this.l_newWinterStationSettingValue.startdate == '' ||
        this.l_newWinterStationSettingValue.enddate == '' ||
        this.l_newWinterStationSettingValue.description == '' ||
        this.l_newWinterStationSettingValue.createdate == ''
      ){
        ret = true
      }else{
        ret = false
      }
      return ret
    },
    getEditButtonAvailability(){
      var ret = true
      if(this.l_editWinterStationSettingValue.name == '' ||
        this.l_editWinterStationSettingValue.keyword == '' ||
        this.l_editWinterStationSettingValue.startdate == '' ||
        this.l_editWinterStationSettingValue.enddate == '' ||
        this.l_editWinterStationSettingValue.description == '' ||
        this.l_editWinterStationSettingValue.createdate == ''
      ){
        ret = true
      }else{
        ret = false
      }
      return ret
    },
		// Interface Wrapper
		// winterStationHideRequest
		getWinterStationHideRequestWrapper : async function(){

      const reqdata = {
				headers: {
					"Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
				},
				params: {
				}
			};

			await axios.get(this.createAPI("systemconfiguration/winterstationhiderequest"),reqdata)
			.then(response => {
				console.log(response)
        var list = response.data.hiddenSettingArray
        var tabledata = []
        for(var i in list){
          tabledata.push({
            '設定名' : list[i].settingName,
            '設定ID' : list[i].settingId,
            'キーワード' : list[i].keyword,
            '説明' : list[i].description,
            '開始日' : list[i].startDate,
            '終了日' : list[i].endDate,
            '有効/無効' : this.getValidStatus(list[i].settingStatus),
            '作成日' : (list[i].creationDate).split(" ")[0],
          })
        }
        this.l_winterStationSettingTableData = tabledata
			})
			.catch(error => {
				console.log("USE LOCAL DUMMY")
				console.log(error)
        this.l_winterStationSettingTableData = [
        ]
			})

		},
    // winterStationHideEditRequest
		requestWinterStationHideEditRequestWrapper : async function(data){
      console.log(data)
      this.l_editSettingProcessing = true

      const hdrdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
      };
      const paramdata = {
          settingName:data.name,
          settingId:data.settingId,
          keyword:data.keyword,
          description:data.description,
          startDate:(data.startdate).replaceAll("-", "/"),
          endDate:(data.enddate).replaceAll("-", "/"),
          settingStatus:(data.valid == false ? "0" : "1")
      };

			await axios.post(this.createAPI("systemconfiguration/winterstationhideeditrequest"), paramdata, hdrdata)
			.then(response => {
        this.getWinterStationHideRequestWrapper()
        this.l_editSettingProcessing = false
        this.l_editSettingCompleted = true
			})
			.catch(error => {
        this.getWinterStationHideRequestWrapper()
        this.l_editSettingProcessing = false
        this.l_editSettingCompleted = true
				console.log("USE LOCAL DUMMY")
				console.log(error)
			})

		},
    // winterStationHideRegistRequest
		requestWinterStationAddRequestWrapper : async function(data){
      console.log(data)
      this.l_addnewSettingProcessing = true

      const hdrdata = {
        headers: {
          "Authorization": this.$store.getters.user.signInUserSession.idToken.jwtToken
        },
      };
      const paramdata = {
          settingName:data.name,
          keyword:data.keyword,
          description:data.description,
          startDate:(data.startdate).replaceAll("-", "/"),
          endDate:(data.enddate).replaceAll("-", "/"),
          settingStatus:(data.valid == false ? "0" : "1")
      };

			await axios.post(this.createAPI("systemconfiguration/winterstationhideregistrequest"), paramdata, hdrdata)
			.then(response => {
        this.getWinterStationHideRequestWrapper()
        this.l_addnewSettingProcessing = false
        this.l_addnewSettingCompleted = true
			})
			.catch(error => {
        this.getWinterStationHideRequestWrapper()
        this.l_addnewSettingProcessing = false
        this.l_addnewSettingCompleted = true
				console.log("USE LOCAL DUMMY")
				console.log(error)
			})

		},
  }
}
</script>
<style scoped>
.newmodal {
	font-family: 'Noto Sans JP', sans-serif;
	-webkit-font-smoothing: subpixel-antialiased;
	-moz-osx-font-smoothing: grayscale;
}

/* 追加ボタンのスタイリング */
.add-setting-btn {
  font-weight: 600;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 123, 255, 0.25);
  transition: all 0.3s ease;
  border: none;
}

.add-setting-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 123, 255, 0.4);
  background-color: #0056b3;
}

.add-setting-btn:active {
  transform: translateY(0);
}

.add-setting-btn i {
  font-size: 1.1em;
}

/* コンテナとカードの枠を美しくするスタイル */
.system-container {
  padding: 0;
  margin: 0;
}

.modern-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background: #ffffff;
}

.modern-card .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 0;
}

.modern-card .nav-tabs {
  border: none;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.modern-card .nav-tabs .nav-link {
  border: none;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 600;
  padding: 15px 25px;
  background: transparent;
  transition: all 0.3s ease;
}

.modern-card .nav-tabs .nav-link.active {
  background: #ffffff;
  color: #667eea;
  border-radius: 0;
}

.modern-card .nav-tabs .nav-link:hover:not(.active) {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.tab-content-wrapper {
  background: #ffffff;
  min-height: 500px;
  border-radius: 0 0 12px 12px;
}

/* テーブルエリアの改善 */
.table {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border: 1px solid #e9ecef;
}

.table thead th {
  background: #f8f9fa;
  border: none;
  font-weight: 600;
  color: #495057;
  padding: 15px 12px;
}

.table tbody td {
  padding: 12px;
  vertical-align: middle;
  border-color: #f1f3f4;
}

.table tbody tr:hover {
  background-color: #f8f9fa;
}
</style>
